import BaseService from "./base";
export class AuthService extends BaseService {
    constructor() {
        super("auth");
    }

    /**
     * @param {string} email
     */
    requestPasswordReset(email) {

        return this.api("request-password-reset", {
            method: "POST",
            body: JSON.stringify({ username: email })

        });
    }

    /**
     * @param {string} token
     * @param {string} password
     */
    changePassword(token, password) {
        return this.api("change-password", {
            method: "POST",
            body: JSON.stringify({ password }),
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    }



}
